import { useTranslation } from "react-i18next";
import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useInfiniteQuery } from "react-query";
import { axiosInstance } from "api/axios";
import SortOrder from "components/SortOrder";
import {
  EOrder,
  ETypeOfOrder,
  IOrderObject,
} from "components/SortOrder/typings";
import Loading from "components/Loading";
import Search from "assets/icons/search.gif";
import { DataGridPremium } from "@mui/x-data-grid-premium";
import { IUser } from "dto/Admin/user";
import UserCard from "components/Admin/UserCard";

const UsersList: FC<Props> = ({ searchText }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [users, setUsers] = useState<IUser[]>([]);

  const [listFilter, setListFilter] = useState<IOrderObject>({
    type: ETypeOfOrder.CREATION_DATE,
    order: EOrder.DESCENDING,
  });

  const [nextPage, setNextPage] = useState(0);

  const {
    data,
    refetch,
    fetchNextPage,
    isLoading,
    status,
  } = useInfiniteQuery(
    ["users", listFilter, searchText],
    async () => {
      const query = new URLSearchParams(window.location.search);

      if (searchText.length) {
        query.append("Text", searchText);
      }

      // if (userId) {
      //   query.append("PageForId", userId);
      // }

      query.append("Page", nextPage.toString());
      query.append("SortProp", listFilter.type);
      query.append("SortOrder", listFilter.order);

      const res = await axiosInstance.get(`/admin/users?${query}`);
      // return res.data;
      return {
        items: res.data,
        LastPage: res.data.LastPage,
        nextPage: nextPage + 1,
      };
    },
    {
      staleTime: 0,
      cacheTime: 0,
      enabled: false,
      getNextPageParam: (lastPage) => {
        if (!lastPage.LastPage) {
          return nextPage + 1;
        }
        return undefined;
      },
    }
  );

  const compileData = async () => {
    if (!data) return;
    setNextPage(data.pages[data.pages.length - 1].nextPage);
    const users = await Promise.all(
      data?.pages
        .map((page) => {
          return page.items.Items;
        })
        .flat()

      // .sort((left: IPackage, right: IPackage) => {
      //   //@ts-ignore
      //   return right.Unread - left.Unread;
      // })
    );

    setUsers(users);
  };

  useEffect(() => {
    compileData();
  }, [data]);

  useEffect(() => {
    if (!listFilter.initalized) return;

    setNextPage(0);
    setUsers([]);
    setTimeout(() => {
      refetch();
    }, 100);
  }, [listFilter]);
  return (
    <div className={styles.wrapper}>
      <div className={styles.order}>
        <SortOrder
          isLoading={false}
          refetch={() => {
            // setNextPage(0);
            // setClients([]);
            // setTimeout(() => {
            //   refetch();
            // }, 100);
          }}
          setListFilter={setListFilter}
          type={listFilter.type}
          order={listFilter.order}
        />
      </div>

      <div className={styles.list}>
        {!users.length && !isLoading && status !== "idle" && (
          <div className={styles.wrapper}>
            <div className={styles.empty}>
              <img src={Search} />
              <div>{t("emptyStates.noResults")}</div>
            </div>
          </div>
        )}

        {isLoading && <Loading />}
        {!isLoading && (
          <DataGridPremium
            sx={{
              border: "none",
              "& .MuiDataGrid-row:hover": {
                backgroundColor: "transparent",
              },
              "& .MuiDataGrid-cell:focus": {
                backgroundColor: "transparent",
              },
              "& .MuiDataGrid-cell:focus-within": {
                backgroundColor: "transparent",
              },
              "& .Mui-selected": {
                backgroundColor: "transparent !important",
              },
            }}
            getRowHeight={() => "auto"}
            columnHeaderHeight={0}
            onRowsScrollEnd={() => {
              fetchNextPage();
            }}
            onRowClick={(a) => {
              const user = a.row as IUser;
              navigate(`/admin/users/${user.Id}`);
            }}
            columns={[
              {
                flex: 1,
                field: "name",
                renderCell: (props) => {
                  const user = props.row as IUser;

                  return (
                    <UserCard
                      key={user.Id}
                      refetch={() => {}}
                      setSelectedEdit={() => {}}
                      client={user}
                    />
                  );
                },
              },
            ]}
            hideFooter={true}
            rows={users.map((c) => {
              // @ts-expect-error id not in IUser
              c.id = c.Id;
              return c;
            })}
          />
        )}
      </div>
    </div>
  );
};

export default UsersList;
